module.exports = function getResource(label, vars = []) {
    const resources = {
        modalTitle: 'Change Method',
        standard: 'Standard',
        sameDayDelivery: 'Same-Day Delivery',
        bopis: 'Buy Online & Pick Up',
        checkAvailability: 'Check availability',
        confirm: 'Confirm',
        cancel: 'Cancel',
        bopisUnavailable: 'Buy Online & Pick Up is temporarily unavailable.',
        sameDayUnavailable: 'Same-Day Delivery is temporarily unavailable.'
    };

    return resources[label];
};
